import React from 'react';
import { compose } from 'redux';
import { Form, reduxForm } from 'redux-form';
import Button from '../../../../components/Button';
import CloakLoading from '../../../../components/CloakLoading';
import { FormField } from '../../../../components/CustomForm';
import PaddingBox from '../../../../components/PaddingBox';
import { PasswordTextBoxAdapter } from '../../../../components/adapters/form/PasswordTextBox';
import { codes } from '../../../../data/translations';
import { confirmation, length, required } from '../../../../utils/formValidators';
import { FORM_NEW_PASSWORD_NAME } from '../../../authentication/consts';
import AuthenticationErrorsBox from '../AuthenticationErrorsBox';
import AuthenticationNewPasswordController from './decorators/authenticationNewPasswordController';

const AuthenticationNewPasswordFormComponent = ({
	handleSubmit,
	handleFormSubmit,
	translate,
	passwordRules,
	isPending,
	errors,
}) => {
	return (
		<>
			{isPending && <CloakLoading />}
			{errors && Object.keys(errors).length > 0 && <AuthenticationErrorsBox errors={errors} />}
			<Form onSubmit={handleSubmit(handleFormSubmit)}>
				<FormField
					component={PasswordTextBoxAdapter}
					name='password'
					validate={[
						required(),
						length({
							min: passwordRules.passwordMinimumLength,
							max: 32,
						}),
					]}
					controlProps={{ label: translate(codes.user.password), isRequired: true }}
					componentProps={{ autoFocus: true }}
				/>
				<PaddingBox topTiny>
					<FormField
						component={PasswordTextBoxAdapter}
						name='confirmPassword'
						validate={[
							confirmation({
								field: 'password',
								message: translate(codes.user.confirmPasswordValidation),
							}),
							length({
								min: passwordRules.passwordMinimumLength,
								max: 32,
							}),
						]}
						controlProps={{
							label: translate(codes.user.confirmPassword),
							isRequired: true,
						}}
					/>
				</PaddingBox>
				<PaddingBox topSmall>
					<Button
						type='submit'
						primary
						block
						size='small'
						disabled={isPending}
					>
						{translate(codes.apply)}
					</Button>
				</PaddingBox>
			</Form>
		</>
	);
};

export const AuthenticationNewPasswordForm = compose(
	reduxForm({
		form: FORM_NEW_PASSWORD_NAME,
		enableReinitialize: true,
	}),
	AuthenticationNewPasswordController,
)(AuthenticationNewPasswordFormComponent);
